import { AfterViewInit, DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwiperSlideComponent } from './swiper-slide.component';
import { fromEvent } from 'rxjs';
import { SwiperContainerComponent } from './swiper-container.component';

@Directive({
  selector: 'video[swiperControl]',
  standalone: true,
})
export class SwiperVideoControlDirective implements AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly swiperContainer = inject(SwiperContainerComponent, { host: true });
  private readonly swiperSlide = inject(SwiperSlideComponent, { host: true } );
  private readonly elementRef = inject<ElementRef<HTMLVideoElement>>(ElementRef);

  public ngAfterViewInit() {
    const swiperElement = this.swiperContainer.elementRef.nativeElement;
    const videoElement = this.elementRef.nativeElement;

    let autoplayStop = false;
    fromEvent(videoElement, 'play').pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      if (!swiperElement.swiper.autoplay.running) {
        return;
      }

      autoplayStop = true;

      swiperElement.swiper.autoplay.stop();
    });

    fromEvent(videoElement, 'ended').pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      if (!swiperElement.autoplay || !autoplayStop) {
        return;
      }

      autoplayStop = false;

      swiperElement.swiper.slideNext();
      swiperElement.swiper.autoplay.start();
    });

    this.swiperSlide.active$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((active) => {
      videoElement.currentTime = 0;

      if (active) {
        void videoElement.play().catch((error: unknown) => {
          if (error instanceof DOMException && error.name === 'AbortError') {
            return;
          }

          throw error;
        });
      } else {
        videoElement.pause();
      }
    });
  }

}
